module.exports = __webpack_public_path__ + "img/partners.fd01f791.png";